import React from 'react';

type Props = {
  open: boolean;
  onClose: () => void;
  onSelect: (icon: string) => void;
};

const icons: { name: string; render: React.ReactNode }[] = [
  { name: 'help', render: (<svg viewBox="0 0 24 24" className="h-6 w-6" fill="none" stroke="currentColor" strokeWidth="2"><circle cx="12" cy="12" r="10"/><path d="M9.09 9a3 3 0 1 1 5.83 1c0 2-3 2-3 4"/><line x1="12" y1="17" x2="12.01" y2="17"/></svg>) },
  { name: 'star', render: (<svg viewBox="0 0 24 24" className="h-6 w-6" fill="currentColor"><path d="M12 17.27 18.18 21l-1.64-7.03L22 9.24l-7.19-.61L12 2 9.19 8.63 2 9.24l5.46 4.73L5.82 21z"/></svg>) },
  { name: 'check', render: (<svg viewBox="0 0 24 24" className="h-6 w-6" fill="none" stroke="currentColor" strokeWidth="2"><polyline points="20 6 9 17 4 12"/></svg>) },
  { name: 'info', render: (<svg viewBox="0 0 24 24" className="h-6 w-6" fill="none" stroke="currentColor" strokeWidth="2"><circle cx="12" cy="12" r="10"/><line x1="12" y1="16" x2="12" y2="12"/><line x1="12" y1="8" x2="12.01" y2="8"/></svg>) },
  { name: 'bolt', render: (<svg viewBox="0 0 24 24" className="h-6 w-6" fill="none" stroke="currentColor" strokeWidth="2"><path d="M13 10V3L4 14h7v7l9-11h-7z"/></svg>) },
  { name: 'sparkles', render: (<svg viewBox="0 0 24 24" className="h-6 w-6" fill="none" stroke="currentColor" strokeWidth="2"><path d="M12 3l1.5 3.5L17 8l-3.5 1.5L12 13l-1.5-3.5L7 8l3.5-1.5L12 3z"/><path d="M5 14l1 2 2 1-2 1-1 2-1-2-2-1 2-1 1-2z"/><path d="M18 14l.75 1.75L20.5 16.5 18.75 17.25 18 19l-.75-1.75L15.5 16.5l1.75-.75L18 14z"/></svg>) },
];

const IconGallery: React.FC<Props> = ({ open, onClose, onSelect }) => {
  if (!open) return null;
  return (
    <div className="fixed inset-0 z-[95] flex items-center justify-center">
      <div className="absolute inset-0 bg-black/40" onClick={onClose} />
      <div className="relative z-10 w-[min(900px,96vw)] max-h-[88vh] bg-white rounded-2xl shadow-2xl border border-gray-200 flex flex-col">
        <div className="flex items-center gap-2 px-5 py-3 border-b border-gray-100">
          <div className="font-semibold text-gray-900">Icon Gallery</div>
          <div className="ml-auto inline-flex items-center gap-2">
            <button className="inline-flex h-8 items-center gap-2 rounded-md border border-gray-200 px-2 text-sm hover:bg-gray-50" onClick={onClose}>
              Close
            </button>
          </div>
        </div>
        <div className="p-5 overflow-auto">
          <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-6 gap-3">
            {icons.map(ic => (
              <button
                key={ic.name}
                className="group flex flex-col items-center gap-2 rounded-xl border border-gray-200 p-3 hover:border-purple-300 hover:bg-purple-50 transition"
                onClick={() => { onSelect(ic.name); onClose(); }}
                title={ic.name}
              >
                <span className="inline-flex h-12 w-12 items-center justify-center rounded-lg bg-purple-50 text-purple-700 ring-1 ring-purple-200 group-hover:ring-purple-300">
                  {ic.render}
                </span>
                <span className="text-xs font-medium text-gray-700 capitalize">{ic.name}</span>
              </button>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
};

export default IconGallery;
